import React from 'react';

// Wrapper to properly enable generics with memorized components:
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
export const genericMemo: <T>(c: T) => T = React.memo;
